import { EventShieldReason } from 'matrix-js-sdk/lib/crypto-api';
export const MEGOLM_ALGORITHM = 'm.megolm.v1.aes-sha2';

export const EVENT_SHIELD_REASONS: Record<EventShieldReason, string> = {
	[EventShieldReason.UNKNOWN]: 'Unable to determine the authenticity of this encrypted message.',
	[EventShieldReason.UNVERIFIED_IDENTITY]: 'Encrypted by an unverified user.',
	[EventShieldReason.UNSIGNED_DEVICE]: 'Encrypted by a device not verified by its owner.',
	[EventShieldReason.UNKNOWN_DEVICE]: 'Encrypted by an unknown or deleted device.',
	[EventShieldReason.AUTHENTICITY_NOT_GUARANTEED]:
		"The authenticity of this encrypted message can't be guaranteed on this device.",
	[EventShieldReason.VERIFICATION_VIOLATION]:
		"The sender's previously verified identity has changed.",
	[EventShieldReason.MISMATCHED_SENDER]:
		'The sender does not match the owner of the encrypting device.',
	[EventShieldReason.MISMATCHED_SENDER_KEY]: 'Encrypted by an unexpected device.',
	[EventShieldReason.SENT_IN_CLEAR]: 'Sent unencrypted in an encrypted room.'
};
